// Answers sent from the web without Aleta (guest_<hex>) carry only the name the
// person typed. One that names someone else who also answered (a member who
// answered in the app, or another web answer) is probably the same person twice:
// the junta sees it marked and decides which one to delete.

const normalize = (text) => String(text || '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .replace(/[^a-z0-9]+/g, ' ')
  .trim();

const isGuest = (userId) => String(userId).startsWith('guest_');

const namesOf = (userId, response, castellersInfo) => {
  const person = castellersInfo?.[userId];
  const names = person
    ? [person.mote, person.nom, `${person.nom || ''} ${person.cognom || ''}`, `${person.nom || ''} ${person.cognom || ''} ${person.segon_cognom || ''}`]
    : [response?.mote];
  return new Set(names.map(normalize).filter((name) => name.length >= 3 && name !== 'visitant'));
};

// Whether a name typed on the web is someone of the colla's (hidden ones too), to
// suggest the app before answering: the nickname or the name with the surnames.
// The first name alone would find every Marta of the colla.
// The members a typed name can be, to ask «Ets tu?»: { id, name } with their
// name and surname as the colla knows them
export const membersNamed = (typed, castellersInfo = {}) => {
  const name = normalize(typed);
  if (name.length < 3 || name === 'visitant') return [];
  return Object.entries(castellersInfo || {})
    .filter(([id, person]) => !isGuest(id) && [
      person?.mote,
      `${person?.nom || ''} ${person?.cognom || ''}`,
      `${person?.nom || ''} ${person?.cognom || ''} ${person?.segon_cognom || ''}`,
    ].map(normalize).includes(name))
    .map(([id, person]) => ({
      id: Number(id),
      name: [person?.nom, person?.cognom].filter(Boolean).join(' ') || person?.mote || '',
      mote: person?.mote || '',
    }));
};

export const isMemberName = (typed, castellersInfo = {}) => membersNamed(typed, castellersInfo).length > 0;

// The indexes of the web answers that share a name with another answer
export const possibleDuplicates = ({ userIds = [], responses = [], castellersInfo = {} }) => {
  const names = userIds.map((userId, index) => namesOf(userId, responses[index], castellersInfo));
  const duplicates = new Set();
  userIds.forEach((userId, index) => {
    if (!isGuest(userId) || castellersInfo?.[userId]) return;
    const [typed] = names[index];
    if (!typed) return;
    if (names.some((other, otherIndex) => otherIndex !== index && other.has(typed))) duplicates.add(index);
  });
  return duplicates;
};
